/* eslint-disable quotes */
import type { Color, ColorContrast, ColorSchema, Theme } from "themes/interfaces";
import { BaseBorder, BaseColor, BaseComponent, BaseFont, BaseSpacing } from "themes/base";
import { Enums } from "utils";

export const Dark: Theme = {
  id: Enums.EnumTheme.Dark,
  font: BaseFont,
  color: {
    ...BaseColor,
    theme: { color: "#202020" } as ColorSchema,
    border: { color: "#505050", accent: "#808080" } as ColorContrast,
    shadow: { color: "0 3px 10px 0 #D0D0D0" } as ColorContrast,
    overlay: { color: "rgba(0, 0, 0, 0.5)" } as ColorContrast,
    input: { color: "#FFFFFF", accent: "#DBDBDB" } as ColorSchema,
    font: { color: "#FFFFFF", accent: "#666666" } as ColorContrast,
    background: { color: "#101010", accent: "#272727", textAccent: "#404040" } as ColorSchema,
    primary: { color: "#fdebc9", accent: "#f8df9f", text: "#333333", textAccent: "#333333" } as ColorSchema,
    accent: { color: "#FFAC4B", text: "#FFFFFF" } as ColorSchema,
    secondary: { color: "#272727", text: "#FFFFFF" } as ColorSchema,
    disabled: { color: "#303030", text: "#A6A6A6" } as ColorSchema,
  } as Color,
  border: BaseBorder,
  spacing: BaseSpacing,
  component: BaseComponent,
};
